(function(){
  function init(root){
    if(!root||root.dataset.khvReady)return;root.dataset.khvReady='1';
    var track=root.querySelector('[data-track]');if(!track)return;
    var slides=[].slice.call(track.children),n=slides.length,i=0,timer=null;
    var dotsWrap=root.querySelector('[data-dots]'),live=root.querySelector('[data-live]');
    var prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay=root.getAttribute('data-autoplay')!=='false',speed=parseInt(root.getAttribute('data-speed'),10)||5500;
    if(n<2){if(prev)prev.hidden=true;if(next)next.hidden=true;return;}
    slides.forEach(function(_,k){var b=document.createElement('button');b.type='button';b.className='khv__dot';b.setAttribute('aria-label','Show slide '+(k+1));b.addEventListener('click',function(){go(k,true)});dotsWrap.appendChild(b)});
    var dots=[].slice.call(dotsWrap.children);
    function go(k,user){i=(k+n)%n;track.style.transform='translateX('+(-100*i)+'%)';
      dots.forEach(function(d,j){d.setAttribute('aria-current',j===i?'true':'false')});
      slides.forEach(function(s,j){s.setAttribute('aria-hidden',j===i?'false':'true');var a=s.querySelector('a');if(a)a.tabIndex=j===i?0:-1});
      if(user){if(live)live.textContent='Slide '+(i+1)+' of '+n;restart()}}
    function restart(){if(reduce||!autoplay)return;clearInterval(timer);timer=setInterval(function(){go(i+1)},speed)}
    prev.addEventListener('click',function(){go(i-1,true)});
    next.addEventListener('click',function(){go(i+1,true)});
    var vp=track.parentNode;
    vp.addEventListener('mouseenter',function(){clearInterval(timer)});vp.addEventListener('mouseleave',restart);
    vp.addEventListener('focusin',function(){clearInterval(timer)});
    var x0=null;
    vp.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;clearInterval(timer)},{passive:true});
    vp.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1),true);else restart();x0=null});
    vp.addEventListener('keydown',function(e){if(e.key==='ArrowRight')go(i+1,true);if(e.key==='ArrowLeft')go(i-1,true)});
    go(0);restart();
  }
  function all(){document.querySelectorAll('.khv').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('.khv'))});
})();
